(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-collection-list"] && !Shopify.designMode) return;
  try {
    
  const syncCustomCollectionRow = (row) => {
    const scroller = row.querySelector('slideshow-slides');
    const component = row.querySelector('slideshow-component');
    if (!scroller || !component) return;

    const overflows = scroller.scrollWidth > scroller.clientWidth + 1;
    component.disabled = !overflows;
  };

  const initCustomCollectionRows = (root) => {
    const scope = root instanceof Element || root instanceof Document ? root : document;
    scope.querySelectorAll('.custom-collection-row').forEach((row) => {
      if (!(row instanceof HTMLElement) || row.dataset.rowReady === 'true') return;
      row.dataset.rowReady = 'true';

      const scroller = row.querySelector('slideshow-slides');
      const sync = () => syncCustomCollectionRow(row);
      sync();
      requestAnimationFrame(sync);

      if (scroller instanceof HTMLElement && 'ResizeObserver' in window) {
        const observer = new ResizeObserver(sync);
        observer.observe(scroller);
      }

      scroller?.addEventListener('scroll', sync, { passive: true });
    });
  };

  initCustomCollectionRows(document);
  document.addEventListener('shopify:section:load', (event) => {
    initCustomCollectionRows(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
